import Audio from './Audio';

function Message({ message, participant }) {
    return (
        <article className="Message" data-participant={message?.participant}>
            <div className="Message-participant">{participant?.name}</div>
            <div className="Message-bubble">
                {message?.audio?.src && <Audio data={message?.audio}></Audio>}
                <div className="Message-text">{message?.text}</div>
                {message?.meta && <div className="Message-meta">{message.meta}</div>}
            </div>
        </article>
    );
}

export default Message;
